import dayjs from "dayjs";

export type PeriodStatus = "ACTIVE" | "UPCOMING" | "PAST";

type Period = { effectiveFrom: string; effectiveTo: string };

export const PERIOD_STATUS_ORDER: PeriodStatus[] = [
  "UPCOMING",
  "ACTIVE",
  "PAST",
];

export const periodStatusChips: Record<
  PeriodStatus,
  { label: string; color: "success" | "info" | "default" }
> = {
  ACTIVE: { label: "Active", color: "success" },
  UPCOMING: { label: "Upcoming", color: "info" },
  PAST: { label: "Past", color: "default" },
};

export const periodStatus = (period: Period): PeriodStatus => {
  const today = dayjs();

  if (dayjs(period.effectiveTo).isBefore(today, "day")) return "PAST";
  if (dayjs(period.effectiveFrom).isAfter(today, "day")) return "UPCOMING";
  return "ACTIVE";
};
